import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Flowise from "../components/FlowChartComponent/"
import TypebotIframe from "../components/TypebotChartComponentIframe/"
import Signup from "../pages/Signup";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import SettingsCustom from "../pages/SettingsCustom/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import OutrosAjustes from "../pages/OutrosAjustes/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import Companies from "../pages/Companies/";
import QuickMessages from "../pages/QuickMessages/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Integrations from '../pages/Integrations';
import MikWebComponent from '../pages/Integrations/components/MikWebComponent';
import Ratings from "../pages/Ratings/";
import ToDoList from "../pages/ToDoList/";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban/";
import ForgetPassword from "../pages/ForgetPassWord/";
import Email from "../pages/Email/";
import EmailLis from "../pages/EmailLis/";
import EmailScheduler from "../pages/EmailScheduler/";
import EmailsAgendado from "../pages/EmailsAgendado/";
import ChatGPT from "../pages/ChatGPT/";
import Calendario from "../pages/Calendario/";
import campanhaAvancada from "../pages/campanhaAvancada/";
import kanbanAgendamentos from "../pages/kanbanAgendamentos/";
import NewMessage from "../pages/NewMessage";
import FlowBuilder from "../pages/FlowBuilder";
import { ChatContextProvider } from "../context/InternalChatContext/InternalChatContext";
import SatisfactionDashboard from "../pages/ReportsRating";
import { useLicenseChecker } from "../license/validateLicense";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import WhatsAppStatus from "../pages/WhatsAppStatus";
import WhatsAppStatusList from "../pages/WhatsAppStatusList";
import Calls from "../pages/Calls";

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);
  const { plano } = useLicenseChecker();

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
              <Route exact path="/signup" component={Signup} />)}
            <Route exact path="/forgetpsw" component={ForgetPassword} />
            {(plano === "empresarial" || plano === "ultimate") && (
              <Route exact path="/financeiro-aberto" component={Financeiro} isPrivate />)}
            <WhatsAppsProvider>
              <LoggedInLayout>
                <ChatContextProvider>
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/companies" component={Companies} isPrivate />
                  )}
                  <Route exact path="/dashboard" component={Dashboard} isPrivate />
                  <Route exact path="/tickets/:ticketId?" component={TicketResponsiveContainer} isPrivate />
                  <Route exact path="/" component={TicketResponsiveContainer} isPrivate />
                  <Route exact path="/connections" component={Connections} isPrivate />
                  <Route exact path="/whatsapp-status" component={WhatsAppStatus} isPrivate />
                  <Route exact path="/whatsapp-status-list" component={WhatsAppStatusList} isPrivate />
                  <Route exact path="/calls" component={Calls} isPrivate />
                  <Route exact path="/quick-messages" component={QuickMessages} isPrivate />
                  <Route exact path="/schedules" component={Schedules} isPrivate />
                  <Route exact path="/flowbuilders" component={FlowBuilder} isPrivate />
                  <Route
                    exact
                    path="/flowbuilder/:id?"
                    component={FlowBuilderConfig}
                    isPrivate
                  />
                  <Route
                    exact
                    path="/assessmentReport"
                    component={SatisfactionDashboard}
                    isPrivate
                  />
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/financeiro" component={Financeiro} isPrivate />
                  )}
                  <Route exact path="/tags" component={Tags} isPrivate />
                  <Route exact path="/contacts" component={Contacts} isPrivate />
                  <Route exact path="/helps" component={Helps} isPrivate />
                  <Route exact path="/outrosajustes" component={OutrosAjustes} isPrivate />
                  <Route exact path="/users" component={Users} isPrivate />
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/Kanban" component={Kanban} isPrivate />
                  )}
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/TagsKanban" component={TagsKanban} isPrivate />
                  )}
                  <Route exact path="/todolist" component={ToDoList} isPrivate />
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/Email" component={Email} isPrivate />
                  )}
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/EmailLis" component={EmailLis} isPrivate />
                  )}
                  <Route exact path="/EmailScheduler" component={EmailScheduler} isPrivate />
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/EmailsAgendado" component={EmailsAgendado} isPrivate />
                  )}
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/ChatGPT" component={ChatGPT} isPrivate />
                  )}
                  <Route exact path="/Calendario" component={Calendario} isPrivate />
                  <Route exact path="/campanhaAvancada" component={campanhaAvancada} isPrivate />
                  <Route exact path="/campanhas" component={kanbanAgendamentos} isPrivate />

                  <Route exact path="/messages-api" component={MessagesAPI} isPrivate />
                  <Route exact path="/settings" component={SettingsCustom} isPrivate requiredRoles={['admin', 'superadmin']} />
                  <Route exact path="/queues" component={Queues} isPrivate />
                  <Route exact path="/announcements" component={Annoucements} isPrivate />
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/chats/:id?" component={Chat} isPrivate />
                  )}
                  <Route exact path="/ratings" component={Ratings} isPrivate />
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/integrations" component={Integrations} isPrivate />
                  )}
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/integrations/flowise" component={Flowise} isPrivate />
                  )}
                  {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
                    <Route exact path="/integrations/typebotiframe" component={TypebotIframe} isPrivate />
                  )}
                  <Route exact path="/integrations/hinova" component={MikWebComponent} isPrivate />
                  <Route exact path="/integrations/siprov" component={MikWebComponent} isPrivate />
                  <Route exact path="/integrations/mikweb" component={MikWebComponent} isPrivate />
                  <Route exact path="/integrations/bling" component={MikWebComponent} isPrivate />
                  <Route exact path="/n/:telefone?" component={NewMessage} isPrivate />
                  {showCampaigns && (
                    <>
                      <Route exact path="/contact-lists" component={ContactLists} isPrivate />
                      <Route exact path="/contact-lists/:contactListId/contacts" component={ContactListItems} isPrivate />
                      <Route exact path="/campaigns" component={Campaigns} isPrivate />
                      <Route exact path="/campaign/:campaignId/report" component={CampaignReport} isPrivate />
                      <Route exact path="/campaigns-config" component={CampaignsConfig} isPrivate />
                    </>
                  )}
                </ChatContextProvider>
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
